<script>
	import Menu from '../components/Menu.svelte';
	import Footer from '../components/Footer.svelte';
    import SendSms from '../components/SendSms.svelte';
</script>

<Menu showNav={false}/>
<SendSms />
<Footer />